import googleMapLoader from 'google-map-react/lib/loaders/google_map_loader';
import { Sdk, Geocoder } from 'ha/types/GoogleMaps';

interface Config {
  key: string;
  language: string;
}

export default ({ key, language }: Config) => {
  let geocoder: Promise<Geocoder>;

  function createGeocoder() {
    const initializer = googleMapLoader({ key, language });

    return initializer.then((sdk: Sdk) => new sdk.Geocoder());
  }

  return {
    init: () => {
      if (!geocoder) {
        geocoder = createGeocoder();
      }

      return geocoder;
    },
  };
};
